export const visit = (vm, at) => {
at({ "en": { "colorPicker": { "favorites": "Favorites", "popover": { "mode": { "simple": "Simple", "advanced": "Advanced" }, "edit": "Edit", "reset": "Reset to default" } } } });
};